import { render } from "./myBooking.vue?vue&type=template&id=ba747af4&scoped=true"
import script from "./myBooking.vue?vue&type=script&lang=js"
export * from "./myBooking.vue?vue&type=script&lang=js"

import "./myBooking.vue?vue&type=style&index=0&id=ba747af4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba747af4"]])

export default __exports__